import React from 'react';
import { IconProps } from '../../../types/components';

export default function UpRightFromSquareRegular({ iconClass }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      className={`svg-inline--fa ${iconClass || ''}`}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 0 512 512"
    >
      <path
        fill="currentColor"
        d="M312 0c-9.7 0-18.5 5.8-22.2 14.8S288.2 34.1 295 41l71 71-167 167c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l167-167 71 71c6.9 6.9 17.2 8.9 26.2 5.2S512 209.7 512 200l0-176c0-13.3-10.7-24-24-24L312 0zM464 142.1l-94.1-94.1 94.1 0 0 94.1zM80 96C35.8 96 0 131.8 0 176L0 432c0 44.2 35.8 80 80 80l256 0c44.2 0 80-35.8 80-80l0-88c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 88c0 17.7-14.3 32-32 32L80 464c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L80 96z"
      />
    </svg>
  );
}
